import { QuillEmoji } from '@b3networks/shared/common';
import * as QuillNamespace from 'quill';
import { CustomClipboard } from './modules/clipboard-module';
import { MentionData } from './quill-editor.model';

const Quill_lib: any = QuillNamespace;

// custom mention
const Embed = Quill_lib.import('blots/embed');
export class QuillMentionCustom extends Embed {
  static create(value: MentionData) {
    const node = super.create(value);
    node.setAttribute('contenteditable', false);
    node.setAttribute('data-index', value?.index);
    node.setAttribute('data-denotation-char', value?.denotationChar);
    node.setAttribute('data-id', value?.id);
    node.setAttribute('data-value', value?.value);
    node.innerHTML = `<span class="ql-mention-denotation-char">${value?.denotationChar}</span>${value?.value}`;
    return node;
  }

  value() {
    const className = this['domNode']?.className;
    const value = {};
    value[className] = <MentionData>{
      denotationChar: this['domNode'].getAttribute('data-denotation-char'),
      id: this['domNode'].getAttribute('data-id'),
      index: this['domNode'].getAttribute('data-index'),
      value: this['domNode'].getAttribute('data-value')
    };

    return value;
  }
}

QuillMentionCustom['blotName'] = 'mention';
QuillMentionCustom['className'] = 'mention';
QuillMentionCustom['tagName'] = 'span';

const Block = Quill_lib.import('blots/block');
Block.tagName = 'DIV';

export function registerQuillModule() {
  Quill_lib.register({
    'formats/mentionCustom': QuillMentionCustom
  });
  Quill_lib.register(Block, true);
  Quill_lib.register('modules/emoji', QuillEmoji);
  Quill_lib.register('modules/clipboard', CustomClipboard, true);
}
